import { Text, UnstyledButton } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import classes from './VerifyCallout.module.css';

type VerifyOfferProps = {
  label: string;
  /** Sidebar is dark (Siesta chats): brand.7 is too dark, so lift to a brighter shade. */
  dark?: boolean;
  onClick: () => void;
};

/** The "would you like me to…" hand-off link shared by the correction and not-found results. */
export function VerifyOffer({ label, dark, onClick }: VerifyOfferProps) {
  const color = dark ? 'var(--mantine-color-brand-5)' : 'var(--mantine-color-brand-7)';
  return (
    <UnstyledButton type="button" onClick={onClick} className={classes.offer}>
      <Text span size="textSm" fw={FONT_WEIGHTS.semibold} c={color}>
        {label}
      </Text>
    </UnstyledButton>
  );
}
